export class InsertArraivalContactMailResponse {
    result: String;
    message: String | null;

    constructor(
        result: String,
        message: String
    ) {
        this.result = result;
        this.message = message;
    }
}
